module.exports = __webpack_public_path__ + "img/white-main-menu.1a58edb9.svg";